










import Vue, { PropOptions } from 'vue';
const NOINITIALVALUE = 'NoInitialValue';

export interface ISelectOption {
  text: string;
  value: number;
}


export default Vue.extend({
  name: 'SelectBox',
  props: {
    initialValue: {
      type: Number,
      default: 0,
    },
    options: Array as PropOptions<ISelectOption[]>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectValue: 0,
    };
  },
  mounted() {
    let value = this.initialValue;
    // 初期値がない場合
    if (value === 0 && this.options.length >= 0 ) {
      value = this.options[0].value;
    }
    this.selectValue = value;
  },
  watch: {
    selectValue() {
      this.$emit('change', this.selectValue);
    },
    initialValue() {
      this.selectValue = this.initialValue;
    },
  },
});
